import SuppliersBoard from "./SuppliersBoard";
import NewSuppliers from "./NewSuppliers";
import { CustomCard, Title } from "../../Utils/UI/Text";

export default function Suppliers() {
  return (
    <>
      <Title children={"Suppliers"} childrenTwo={<NewSuppliers />} />

      <CustomCard>
        <SuppliersBoard />
      </CustomCard>
    </>
  );
}
